import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "../api/request";

export const createInvestment = (data) => {
  return postRequest("/investment", data);
};

export const getInvestmenets = (data) => {
  return getRequest("/investment", data);
};

export const getPartnerInvestments = (partnerID) => {
  return getRequest(`/investment/partner/${partnerID}`);
};

export const deleteInvestment = (investmentID) => {
  return deleteRequest(`/investment/${investmentID}`);
};

export const updateInvestment = (investmentID, data) => {
  return putRequest(`/investment/${investmentID}`, data);
};

export const getInvestmentStatsAPI = () => {
  return getRequest(`/investment/invest/stats`);
};

export const calculateProfitLoss = (data) => {
  return postRequest(`/investment/invest/stats/profitloss`, data);
};
